<div class="assignments-tab">
  <!-- Left Column: Assignment Fields -->
  <div class="col-md-6">
    <div class="assignments-section">
      <!-- Tractor Assignment -->
      <div class="form-group row">
        <label class="col-sm-4 control-label">Tractor Assignment</label>
        <div class="col-sm-8">
          <div class="d-flex align-items-center gap-2">
            <select
              class="form-control"
              [(ngModel)]="driver.tractorId"
              [disabled]="!isEditMode || loadingTractors"
              (change)="onFieldChange()"
              aria-label="Tractor assignment"
            >
              <option [ngValue]="null">{{ loadingTractors ? "Loading..." : "" }}</option>
              <option *ngFor="let tractor of tractors" [ngValue]="tractor.id">
                {{ tractor.itemName }}
              </option>
            </select>
            <a
              *ngIf="driver.tractorId"
              [href]="'/tractors/' + driver.tractorId"
              target="_blank"
              rel="noopener noreferrer"
              title="Open Tractor"
              class="btn btn-sm btn-outline-secondary flex-shrink-0"
            >
              <i class="fa fa-external-link"></i>
            </a>
          </div>
        </div>
      </div>

      <!-- Trailer Assignment -->
      <div class="form-group row">
        <label class="col-sm-4 control-label">Trailer Assignment</label>
        <div class="col-sm-8">
          <div class="d-flex align-items-center gap-2">
            <select
              class="form-control"
              [(ngModel)]="driver.trailerId"
              [disabled]="!isEditMode || loadingTrailers"
              (change)="onFieldChange()"
              aria-label="Trailer assignment"
            >
              <option [ngValue]="null">{{ loadingTrailers ? "Loading..." : "" }}</option>
              <option *ngFor="let trailer of trailers" [ngValue]="trailer.id">
                {{ trailer.trailerNo }}
              </option>
            </select>
            <a
              *ngIf="driver.trailerId"
              [href]="'/trailers/' + driver.trailerId + '?tab=tripDocuments'"
              target="_blank"
              rel="noopener noreferrer"
              title="Open Trailer Documents"
              class="btn btn-sm btn-outline-secondary flex-shrink-0"
            >
              <i class="fa fa-external-link"></i>
            </a>
          </div>
        </div>
      </div>

      <!-- Client (Scheduling Team) -->
      <div class="form-group row">
        <label class="col-sm-4 control-label">Scheduling Team</label>
        <div class="col-sm-8">
          <div class="d-flex align-items-center gap-2">
            <input
              type="text"
              class="form-control"
              [value]="getSchedulingTeamName()"
              disabled
              placeholder=""
              aria-label="Scheduling team"
            />
            <button
              type="button"
              class="btn btn-sm btn-outline-secondary flex-shrink-0"
              (click)="openAssignModal()"
              title="Assign to scheduling team"
            >
              <i class="fa fa-pencil"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Bill To -->
      <div class="form-group row">
        <label class="col-sm-4 control-label">Bill To</label>
        <div class="col-sm-8">
          <input
            type="text"
            class="form-control"
            [value]="getBillToName()"
            disabled
            placeholder=""
            aria-label="Bill to client"
          />
        </div>
      </div>

      <!-- Board -->
      <div class="form-group row">
        <label class="col-sm-4 control-label">Board</label>
        <div class="col-sm-8">
          <input
            type="text"
            class="form-control"
            [value]="getBoardName()"
            disabled
            placeholder=""
            aria-label="Board name"
          />
        </div>
      </div>

      <div style="margin: 25px 0"></div>

      <!-- Preferred Clients -->
      <div class="form-group row">
        <label class="col-sm-4 control-label">Preferred Clients</label>
        <div class="col-sm-8">
          <div *ngIf="preferredClients.length > 0">
            <div
              *ngFor="let pc of preferredClients; let i = index; trackBy: trackByIndex"
              style="margin-bottom: 10px"
            >
              <div style="display: flex; gap: 10px; align-items: center">
                <select
                  class="form-control"
                  [(ngModel)]="pc.clientId"
                  [disabled]="!isEditMode || loadingClients"
                  (change)="onPreferredClientChange()"
                  [name]="'preferredClient' + i"
                  style="flex: 1"
                  aria-label="Preferred client"
                >
                  <option [ngValue]="null">
                    {{ loadingClients ? "Loading..." : "Select Client" }}
                  </option>
                  <option *ngFor="let client of parentClients" [ngValue]="client.id">
                    {{ client.itemName }}
                  </option>
                </select>
                <button
                  *ngIf="isEditMode"
                  class="button-form-control"
                  (click)="removePreferredClient(i)"
                  aria-label="Remove preferred client"
                >
                  -
                </button>
              </div>
            </div>
          </div>
          <button
            *ngIf="isEditMode"
            class="button-form-control"
            (click)="addPreferredClient()"
            [style.margin-top]="preferredClients.length > 0 ? '5px' : '0'"
            aria-label="Add preferred client"
          >
            +
          </button>
        </div>
      </div>

      <!-- Preferred Area -->
      <div class="form-group row">
        <label class="col-sm-4 control-label">Preferred Area</label>
        <div class="col-sm-8">
          <div *ngIf="preferredAreas.length > 0">
            <div
              *ngFor="let pa of preferredAreas; let i = index; trackBy: trackByIndex"
              style="margin-bottom: 10px"
            >
              <div style="display: flex; gap: 10px; align-items: center">
                <select
                  class="form-control"
                  [(ngModel)]="pa.gasRegionId"
                  [disabled]="!isEditMode || loadingFuelRegions"
                  (change)="onPreferredAreaChange()"
                  [name]="'preferredArea' + i"
                  style="flex: 1"
                  aria-label="Preferred area"
                >
                  <option [ngValue]="null">
                    {{ loadingFuelRegions ? "Loading..." : "Select Region" }}
                  </option>
                  <optgroup *ngFor="let group of getRegionsByCountry()" [label]="group.country">
                    <option *ngFor="let region of group.regions" [ngValue]="region.id">
                      {{ region.name }}
                    </option>
                  </optgroup>
                </select>
                <button
                  *ngIf="isEditMode"
                  class="button-form-control"
                  (click)="removePreferredArea(i)"
                  aria-label="Remove preferred area"
                >
                  -
                </button>
              </div>
            </div>
          </div>
          <button
            *ngIf="isEditMode"
            class="button-form-control"
            (click)="addPreferredArea()"
            [style.margin-top]="preferredAreas.length > 0 ? '5px' : '0'"
            aria-label="Add preferred area"
          >
            +
          </button>
        </div>
      </div>

      <!-- Banned Clients -->
      <div class="form-group row">
        <label class="col-sm-4 control-label">Banned Clients</label>
        <div class="col-sm-8">
          <div *ngIf="bannedClients.length > 0">
            <div
              *ngFor="let bc of bannedClients; let i = index; trackBy: trackByIndex"
              style="margin-bottom: 10px"
            >
              <div style="display: flex; gap: 10px; align-items: center">
                <select
                  class="form-control"
                  [(ngModel)]="bc.clientId"
                  [disabled]="!isEditMode || loadingClients"
                  (change)="onBannedClientChange()"
                  [name]="'bannedClient' + i"
                  style="flex: 1"
                  aria-label="Banned client"
                >
                  <option [ngValue]="null">
                    {{ loadingClients ? "Loading..." : "Select Client" }}
                  </option>
                  <option *ngFor="let client of parentClients" [ngValue]="client.id">
                    {{ client.itemName }}
                  </option>
                </select>
                <button
                  *ngIf="isEditMode"
                  class="button-form-control"
                  (click)="removeBannedClient(i)"
                  aria-label="Remove banned client"
                >
                  -
                </button>
              </div>
            </div>
          </div>
          <button
            *ngIf="isEditMode"
            class="button-form-control"
            (click)="addBannedClient()"
            [style.margin-top]="bannedClients.length > 0 ? '5px' : '0'"
            aria-label="Add banned client"
          >
            +
          </button>
        </div>
      </div>

      <!-- Special Note -->
      <div class="form-group row">
        <label class="col-sm-4 control-label">Special Note</label>
        <div class="col-sm-8">
          <input
            type="text"
            class="form-control"
            [(ngModel)]="driver.specialNote"
            [disabled]="!isEditMode"
            (input)="onFieldChange()"
            placeholder="Enter special note"
            aria-label="Special note"
          />
        </div>
      </div>
    </div>
  </div>

  <!-- Right Column: Assignment History -->
  <div class="col-md-6">
    <div class="assignments-section">
      <h5>Assignment History</h5>
      <p-table
        [value]="assignmentHistory"
        [paginator]="false"
        responsiveLayout="scroll"
        styleClass="p-datatable-sm"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Date</th>
            <th>Type</th>
            <th>Assigned To</th>
            <th>User</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-history>
          <tr>
            <td>{{ history.date | date: "MM/dd/yyyy HH:mm" }}</td>
            <td>{{ history.type }}</td>
            <td>{{ history.assignedTo }}</td>
            <td>{{ history.userName }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="4" class="text-center text-muted">No assignment history</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<!-- Assign to Scheduling Team Modal -->
<app-assign-driver-modal
  [(visible)]="showAssignModal"
  [driverId]="driver.id"
  (assignSuccess)="onAssignOrUpdateSuccess($event)"
  (updateSuccess)="onAssignOrUpdateSuccess($event)"
  (unassignSuccess)="onUnassignSuccess()"
></app-assign-driver-modal>
